<a class="va-card-link-button" (click)="onClick()" [attr.href]="url">
  <div class="link-icon">
    <ng-content select=".link-icon-content"></ng-content>
  </div>

  <!-- Url text -->
  <span>{{ text.key | translate: text.params }}</span>
  <!-- Icon that indicates this will open in a new tab -->
  <ng-container *ngIf="!!navigationIconName">
    <mat-icon>{{ navigationIconName }}</mat-icon>
  </ng-container>
</a>
